import { Link } from "react-router-dom";
import { Facebook, Mail, MapPin, MessageCircle, Phone } from "lucide-react";
import {
  EMAIL,
  FACEBOOK,
  FACEBOOK_HANDLE,
  HOURS,
  NAV_LINKS,
  PHONE_DISPLAY,
  PHONE_TEL,
  WHATSAPP_DISPLAY,
  WHATSAPP_LINK,
} from "../lib/constants";
import logo from "../assets/headerlogo.png";

export default function Footer() {
  return (
    <footer className="bg-[#0f4a91] text-white" data-testid="site-footer">
      <div className="mx-auto grid w-full max-w-[1920px] gap-10 px-5 py-14 md:grid-cols-2 lg:grid-cols-[1.5fr_0.6fr_0.7fr_1fr] lg:px-10 xl:px-[130px]">
        <div>
          <div className="flex items-center gap-3">
            <img src={logo} alt="Be Dental Paradise" className="h-14 w-14 rounded-[8px] object-contain" />
            <div>
              <div className="text-[26px] font-bold leading-tight">Be Dental Paradise</div>
              <div className="mt-1 text-[12px] font-bold uppercase tracking-[0.24em] text-[#ffd60a]">
                Beautiful smiles are created here
              </div>
            </div>
          </div>
          <p className="mt-8 max-w-[520px] text-[17px] leading-relaxed text-white/90">
            Led by Dr. Yanahitza Baro, a Cuban dentist specializing in general dentistry and prosthetic rehabilitation with more than 20 years of clinical experience.
          </p>
          <p className="mt-7 text-[24px] font-medium italic text-[#ffd60a]">
            "We don't treat teeth, we treat people."
          </p>
          <div className="mt-8 flex gap-4">
            <a href={FACEBOOK} target="_blank" rel="noreferrer" className="grid h-12 w-12 place-items-center rounded-full bg-white text-[#0f4a91]" aria-label="Facebook">
              <Facebook className="h-5 w-5" />
            </a>
            <a href={WHATSAPP_LINK} target="_blank" rel="noreferrer" className="grid h-12 w-12 place-items-center rounded-full bg-white text-[#0f4a91]" aria-label="WhatsApp">
              <MessageCircle className="h-5 w-5" />
            </a>
            <a href={`mailto:${EMAIL}`} className="grid h-12 w-12 place-items-center rounded-full bg-white text-[#0f4a91]" aria-label="Email">
              <Mail className="h-5 w-5" />
            </a>
            <a href={`tel:${PHONE_TEL}`} className="grid h-12 w-12 place-items-center rounded-full bg-white text-[#0f4a91]" aria-label="Call">
              <Phone className="h-5 w-5" />
            </a>
          </div>
        </div>

        <div>
          <h2 className="text-[16px] font-extrabold uppercase tracking-[0.35em] text-[#ffd60a]">Navigate</h2>
          <ul className="mt-7 space-y-4 text-[17px]">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to} className="transition hover:text-[#ffd60a]">
                  {link.label}
                </Link>
              </li>
            ))}
            <li><Link to="/location" className="transition hover:text-[#ffd60a]">Location</Link></li>
            <li><Link to="/book" className="transition hover:text-[#ffd60a]">Book Appointment</Link></li>
          </ul>
        </div>

        <div>
          <h2 className="text-[16px] font-extrabold uppercase tracking-[0.35em] text-[#ffd60a]">Hours</h2>
          <ul className="mt-7 space-y-5 text-[16px] text-white/90">
            {HOURS.map((hour) => (
              <li key={hour.d}>
                <div className="font-bold text-white">{hour.d}</div>
                <div>{hour.t}</div>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h2 className="text-[16px] font-extrabold uppercase tracking-[0.35em] text-[#ffd60a]">Get In Touch</h2>
          <ul className="mt-7 space-y-5 text-[17px]">
            <li className="flex items-center gap-3"><Phone className="h-5 w-5 text-[#ffd60a]" /> {PHONE_DISPLAY}</li>
            <li className="flex items-center gap-3"><MessageCircle className="h-5 w-5 text-[#00c896]" /> {WHATSAPP_DISPLAY}</li>
            <li className="flex items-center gap-3 break-all"><Mail className="h-5 w-5 shrink-0 text-[#ffd60a]" /> {EMAIL}</li>
            <li className="flex items-center gap-3"><Facebook className="h-5 w-5 text-[#ffd60a]" /> {FACEBOOK_HANDLE}</li>
            <li className="flex items-center gap-3"><MapPin className="h-5 w-5 text-[#ffd60a]" /> Jamaica - By appointment</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/15">
        <div className="mx-auto w-full max-w-[1920px] px-5 py-5 text-[13px] text-white/65 lg:px-10 xl:px-[130px]">
          &copy; {new Date().getFullYear()} Be Dental Paradise. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
